import React, { useEffect, useRef } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { loadModules } from 'esri-loader';
import { faCar, faTruck, faTachometerAlt } from '@fortawesome/free-solid-svg-icons';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import ReactEcharts from 'echarts-for-react';

import API_PATH from "./../../../constants/config.json";
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

//Start Css code ...
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    padding: '0px',
    '& > *': {
      margin: theme.spacing(1),
      width: '98%',
    },
  },
  rootBox: {
    flexGrow: 1,
  },
  paper: {
    width: '100%',
    boxShadow: 'none',
    padding: "5px"
  },
  container: {
    width: '500px',
    float: 'left',
    background: '#fff',
    borderRadius: '5px',
    height: '87vh',
    padding: '0px',
    border: '1px solid #24618E',
    borderRadius: '5px',
    position: "relative",
    zIndex: 99999
  },
  intersection: {
    top: '120px',
    width: '500px',
    height: 'auto',
    position: 'fixed',
    background: '#fff',
    left: '10px',
    zIndex: '999',
    border: '1px solid #00A75D',
    borderRadius: '5px'
  },
  formHead: {
    padding: '15px 15px 15px 15px',
    '& h3': {
      color: '#24618E',
      fontSize: '25px',
      marginTop: '0px',
      marginBottom: '-10px',
    },
    '& img': {
      width: '100%',
      height: '2px',
    }
  },
  teamsUl: {
    paddingLeft: '5px !important',
    paddingTop: 0,
    margin: 0,
    width: '100%',
    float: 'left',
    '& li': {
      listStyle: 'none',
      float: 'left',
      textAlign: 'center',
      marginLeft: '50px'
    },
  },
  btnIcon: {
    color: '#24618E',
    marginRight: '5px',
  },
  fieldsetname: {
    width: 'auto',
    border: '1px solid rgba(0, 167, 93, 1)',
    margin: '0px',
    marginBottom: "10px",
    padding: '10px',
    borderRadius: '5px',
    '& .MuiPaper-elevation1': {
      boxShadow: 'none',
    }
  },
  simpleBtn: {
    marginTop: '0px',
    border: '1px solid #333',
    color: '#333',
    background: '#fff !important',
    fontSize: '12px',
    width: '110px',
  },
  floatLeftBtn: {
    float: 'left',
  },
  floatRightBtn: {
    float: 'right'
  },
  floatCenterBtn: {
    clear: 'both'
  },
  tableHead: {
    fontWeight: 'bolder',
    textAlign: 'center',
    padding: 0,
    '@media only screen and (max-width: 3500px)': {
      fontSize: '18px',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '22pt',
    },
    '& p': {
      margin: '0',
    }
  },
  titleTD: {
    textAlign: 'left',
    padding: 0,
    '@media only screen and (max-width: 3500px)': {
      fontSize: '18px',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '22pt',
    },
  },
  dataTD: {
    textAlign: 'center',
    padding: 0,
    '@media only screen and (max-width: 3500px)': {
      fontSize: '18px',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '22pt',
    },
  },
  mainbtnDiv: {
    border: '1px solid #24618E',
    borderTop: 'none',
    borderRadius: '0px 0px 5px 5px',
    minHeight: '365px',
    '& .focusBtn': {
      color: "#fff",
      background: '#24618E',
    }
  },
  mapContainer: {
    width: '100% !important',
    height: '75vh !important',
    display: 'block !important',
    border: "1x solid #24618e",
    '& .esri-view-root': {
      height: '100% !important',
      width: '100% !important'
    }
  },
  tableMidBlock: {
    '& td': {
      border: '1px solid #D7D7D7',
      padding: '5px'
    },
    '& th': {
      border: '1px solid #D7D7D7',
      '@media only screen and (max-width: 3500px)': {
        padding: '5px',
      },
      '@media only screen and (min-width: 3501px)': {
        padding: '15px 5px',
      },
      '&:first-child': {
        border: 'none',
      }
    }
  },
}));
//End Css code ...


const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);


//Start MidblockLocationDetails component code
const MidblockLocationDetails = props => {
  const [spacing, setSpacing] = React.useState(2);
  const classes = useStyles();
  const mapRef = useRef();

  const [stationDetails, setStationDetails] = React.useState({});

  const [volumeCountDate, setVolumeCountDate] = React.useState();
  const [volumeClassCountDate, setVolumeClassCountDate] = React.useState();
  const [traffiSpeedCountDate, setTraffiCountDate] = React.useState();

  const [yearList, setYearList] = React.useState([]);
  const [getADTSummery, setGetADTSummery] = React.useState([]);
  const [getTruckPercent, setGetTruckPercent] = React.useState([]);
  const [getADTGrowthFactor, setGetADTGrowthFactor] = React.useState([]);

  const [eChartYear, setEChartYear] = React.useState([]);
  const [eChartData, setEChartData] = React.useState([]);
  const [eChartTrendLineData, setEChartTrendLineData] = React.useState([]);
  const [eChartGet, seteChartGet] = React.useState(0);
  const [getchart, setchart] = React.useState([]);

  useEffect(() => {
    if (props.stationId) {
      loadMap();
      getStationRecentYear();
      getsummaryData();
      GetADTeChart();
    }
  }, [props.stationId]);

  const myOptions = {
    color: ["#3398DB"],
    title: {
      text: null
    },
    grid: {
      bottom: sessionStorage.getItem('MidTabWidth') >= 1200 && sessionStorage.getItem('MidTabWidth') <= 3500 ? '60px' : sessionStorage.getItem('MidTabWidth') >= 3501 ? '75px' : '50px',
      top: '20px',
      left: sessionStorage.getItem('MidTabWidth') >= 1200 && sessionStorage.getItem('MidTabWidth') <= 3500 ? '60px' : sessionStorage.getItem('MidTabWidth') >= 3501 ? '100px' : '50px',
      right: '15px'
    },
    // tooltip: {},
        tooltip: {
            trigger: 'item',
            formatter:(params,index)=>{
              let res='';
              let colorCumulative = ['#696969','#428adc'];
              var colorSpan = (color) => '<span style="display:inline-block;margin-right:5px;margin-top:5px;border-radius:10px;width:9px;height:9px;float:left;background-color:' + color + '"></span>';
              if((params.componentType == "series") && (params.componentSubType == 'line')){
                
                res += '<span style="float:left">' + parseFloat(params.data[0]) + '</span>' +
                ' <br/>' + colorSpan(colorCumulative[1]) + '<span style="float:left">' + params.data[2] +  '</span>';
                }
                
              return res;
            }
          },
    legend: {
      data: []
    },
    xAxis: [{
      type: "value",
      interval: 1,
      min: (eChartYear.length > 1 ? Math.min(...eChartYear) : (eChartYear[0]) - 1),
      max: (eChartYear.length > 1 ? Math.max(...eChartYear) : (eChartYear[0]) + 1),
      splitLine: {
        show: false
      },
      axisLabel: {
        rotate: 45,
        fontSize: sessionStorage.getItem('MidTabWidth') >= 1200 && sessionStorage.getItem('MidTabWidth') <= 3500 ? 13 : sessionStorage.getItem('MidTabWidth') >= 3501 ? 24 : 12,
        formatter: function (value, index) {
          return parseInt(value.toString().replace(",", ""));
        }
      },

    }],

    yAxis: {
      type: 'value',
      // interval: 2000,
      splitLine: {
        show: true
      },
      axisLabel: {
        fontSize: sessionStorage.getItem('MidTabWidth') >= 1200 && sessionStorage.getItem('MidTabWidth') <= 3500 ? 13 : sessionStorage.getItem('MidTabWidth') >= 3501 ? 24 : 12,
      },
      scale: true
    },
    series: [
      {
        name: 'Volume Growth',
        type: 'line',
        // data: eChartData,
        symbolSize: 16,
        data: getchart,
        lineStyle: {
          type: 'solid',
          color: "#3b3b3b",
          width: 3
        },
      },
      {
        type: 'line',
        data: eChartTrendLineData,
        symbol: 'none',
        lineStyle: {
          type: 'dashed',
          color: "#7e9ed6",
          width: 3
        },
        label: {
          show: false
        },
      }
    ]
  };

  const regression = (x, y, typ) => {
    var type = (typ == null) ? 'linear' : typ;
    var N = x.length;
    var slope;
    var intercept;
    var SX = 0;
    var SY = 0;
    var SXX = 0;
    var SXY = 0;
    var SYY = 0;
    var Y = [];
    var X = [];

    if (type == 'linear') {
      X = x;
      Y = y;
    }
    else if (type == 'exp' || type == 'exponential') {
      for (var i = 0; i < y.length; i++) {
        if (y[i] <= 0) {
          N--;
        }
        else {
          X.push(x[i]);
          Y.push(Math.log(y[i]));
        }
      }
    }

    for (var i = 0; i < N; i++) {
      SX = SX + X[i];
      SY = SY + Y[i];
      SXY = SXY + X[i] * Y[i];
      SXX = SXX + X[i] * X[i];
      SYY = SYY + Y[i] * Y[i];
    }

    slope = (N * SXY - SX * SY) / (N * SXX - SX * SX);
    intercept = (SY - slope * SX) / N;

    return [slope, intercept];
  }

  const linearRegression = (X, Y) => {
    var ret;
    ret = regression(X, Y, 'linear');
    return [ret[0], ret[1]];
  }

  const expRegression = (X, Y) => {
    var ret;
    var x = X;
    var y = Y;
    ret = regression(x, y, 'exp');
    var base = Math.exp(ret[0]);
    var coeff = Math.exp(ret[1]);
    return [base, coeff];
  }

  const fitData = (data, typ) => {
    var type = (typ == null) ? 'linear' : typ;
    var ret;
    var res;
    var x = [];
    var y = [];
    var ypred = [];

    for (i = 0; i < data.length; i++) {
      if (data[i] != null && Object.prototype.toString.call(data[i]) === '[object Array]') {
        if (data[i] != null && data[i][0] != null && data[i][1] != null) {
          x.push(data[i][0]);
          y.push(data[i][1]);
        }
      }
      else if (data[i] != null && typeof data[i] === 'number') {//If type of X axis is category
        x.push(i);
        y.push(data[i]);
      }
      else if (data[i] != null && Object.prototype.toString.call(data[i]) === '[object Object]') {
        if (data[i] != null && data[i].x != null && data[i].y != null) {
          x.push(data[i].x);
          y.push(data[i].y);
        }
      }
    }

    if (type == 'linear') {

      ret = linearRegression(x, y);
      for (var i = 0; i < x.length; i++) {
        res = ret[0] * x[i] + ret[1];
        ypred.push([x[i], res]);
      }

      return {
        data: ypred,
        slope: ret[0],
        intercept: ret[1],
        y: function (x) {
          return (this.slope * x) + this.intercept;
        },
        x: function (y) {
          return (y - this.intercept) / this.slope;
        }
      };
    }
    else if (type == 'exp' || type == 'exponential') {

      ret = expRegression(x, y);
      for (var i = 0; i < x.length; i++) {
        res = ret[1] * Math.pow(ret[0], x[i]);
        ypred.push([x[i], res]);
      }
      ypred.sort();

      return {
        data: ypred,
        base: ret[0],
        coeff: ret[1]
      };
    }
  }

//This method is use for mapview ... start
  const loadMap = () => {
    loadModules(['esri/Map', 'esri/views/MapView', "esri/widgets/Home", "esri/widgets/Zoom", "esri/layers/FeatureLayer", "esri/Viewpoint", "esri/geometry/Point", "esri/Graphic", "esri/layers/GraphicsLayer", "esri/symbols/PictureMarkerSymbol", "esri/widgets/Search"], { css: true })
      .then(async ([ArcGISMap, MapView, Home, Zoom, FeatureLayer, Viewpoint, Point, Graphic, GraphicsLayer, PictureMarkerSymbol, Search]) => {
        const map = new ArcGISMap({
          basemap: 'topo-vector',
          slider: false
        });

        let view = new MapView({
          container: mapRef.current,
          map: map,
          ui: {
            components: ['home', 'locate']
          },
        });
        let featureLayer = new FeatureLayer({
          url: sessionStorage.getItem('mapURL')
        });
        featureLayer.when(function () {
          let vp = new Viewpoint({
            targetGeometry: featureLayer.fullExtent
          });
          view.extent = featureLayer.fullExtent;

        });
        map.add(featureLayer);
        let position = await getStationDetails();
        featureLayer.when(async function () { // adds feature layer to map view          
          let point = new Point(position.longitude, position.latitude);
          let pointSymbol = {
            type: "simple-marker",
            style: "circle",
            color: "#00A75D",
            size: 20,
            outline: {
              color: "#24618e",
              width: 0.5
            }
          }
          let pointGraphic = new Graphic(point, pointSymbol);
          view.graphics.add(pointGraphic);
          view.goTo(pointGraphic).then(function () {
            view.zoom = view.zoom + 5;
          });
        });
      });
  }
 //This method is use for mapview ... start


  //This method is use for getStationDetails for station data ... start
  const getStationDetails = () => {
    try {
      return axios({
        method: 'get',
        url: API_URL + API_PATH.getStationDetail + props.stationId,
      })
        .then(async function (response) {
          setStationDetails(response.data.data);
          return {
            latitude: response.data.data.latitude,
            longitude: response.data.data.longitude
          }
        })
        .catch(function (error) {
          // console.log(error);
        })
    }
    catch (error) {
    }
  }
//This method is use for getStationDetails for station data ... end


  //This method is use for get recent year data ... start
  const getStationRecentYear = () => {
    try {
      axios({
        method: 'post',
        url: API_URL + API_PATH.getStationRecentYear,
        data: {
          stationId: props.stationId
        }
      }).then(function (response) {
        if (response && response.data.data) {
          setVolumeCountDate(response.data.data.volumeyear);
          setVolumeClassCountDate(response.data.data.classyear);
          setTraffiCountDate(response.data.data.speedyear);
        } else {
          //Data Not Found
        }
      })
    }
    catch (error) {
      // Throw Error
    }
  }
  //This method is use for get recent year data ... end


  //This method is use for GetADTeChart ... start
  const GetADTeChart = () => {
    try {
      axios({
        method: 'post',
        url: API_URL + API_PATH.getADT,
        data: {
          stationId: props.stationId,
        }
      }).then(function (response) {
        if (response && response.data.data) {
          let ADTData = [];
          let ADTYear = [];
          let datas = [];

          seteChartGet(response.data.data.length);
          for (let i = 0; i < response.data.data.length; i++) {

            let adt = parseInt(response.data.data[i].adt.replace(/,/g, ''));
            let adtHover = response.data.data[i].adt;

            let year = parseInt(response.data.data[i].cnt_year);

            datas.push([year, adt, adtHover]);

            ADTData.push(adt);
            ADTYear.push(year);
          }

          let trend_source_data = [];

          for (let i = ADTData.length; i-- > 0;) {
            trend_source_data[i] = [i, ADTData[i]]
          }
          let regression_data = fitData(trend_source_data).data
          let trend_line_data = [];
          for (let i = regression_data.length; i-- > 0;) {
            trend_line_data[i] = regression_data[i][1];
          }

          let trendArray = [];

          trend_line_data.map((trendValue, index) => {

            trendArray.push([datas[index][0], trendValue])
          })
          let tempData = findLineByLeastSquares(ADTYear, ADTData).reverse();
          setEChartTrendLineData(tempData);

          let yearADT = ADTYear.map((i) => parseInt(i));

          setEChartData(ADTData.reverse());

          setEChartYear(yearADT.reverse());

          setchart(datas);

        }
        else {
          // not found data
        }

      })
    }
    catch (error) {
      console.log(error);
    }
  }
  //This method is use for GetADTeChart ... end
  
  

  function findLineByLeastSquares(values_x, values_y) {
    var x_sum = 0;
    var y_sum = 0;
    var xy_sum = 0;
    var xx_sum = 0;
    var count = 0;

    /*
     * The above is just for quick access, makes the program faster
     */
    var x = 0;
    var y = 0;
    var values_length = values_x.length;

    if (values_length != values_y.length) {
      throw new Error('The parameters values_x and values_y need to have same size!');
    }

    /*
     * Above and below cover edge cases
     */
    if (values_length === 0) {
      return [[], []];
    }

    /*
     * Calculate the sum for each of the parts necessary.
     */
    for (let i = 0; i < values_length; i++) {
      x = values_x[i];
      y = values_y[i];
      x_sum += x;
      y_sum += y;
      xx_sum += x * x;
      xy_sum += x * y;
      count++;
    }

    /*
     * Calculate m and b for the line equation:
     * y = x * m + b
     */
    var m = (count * xy_sum - x_sum * y_sum) / (count * xx_sum - x_sum * x_sum);
    var b = (y_sum / count) - (m * x_sum) / count;

    /*
     * We then return the x and y data points according to our fit
     */
    var result_values_x = [];
    var result_values_y = [];

    var totalRsult = [];

    for (let i = 0; i < values_length; i++) {
      x = values_x[i];
      y = x * m + b;
      result_values_x.push(x);
      result_values_y.push(y);

      totalRsult.push([x, y]);
    }

    return totalRsult;    
  }



  const getsummaryData = () => {
    try {
      axios({
        method: 'post',
        url: API_URL + API_PATH.getMidblockSummary,
        data: {
          stationId: props.stationId
        }
      }).then(function (response) {
        if (response && response.data.data) {
          setGetADTSummery(response.data.data[0].adt);
          setGetTruckPercent(response.data.data[1].truckpercent);
          setGetADTGrowthFactor(response.data.data[2].growthrate);
          setYearList(response.data.data[0].adt);
        } else {
          console.log("");
        }
      })
    }
    catch (error) {
      // Throw Error
    }
  }

  return (
    <React.Fragment>
      <CssBaseline />
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <div className={classes.midBlock}>
            <fieldset className={classes.fieldsetname} style={{ paddingTop: 0, marginTop: 0 }}>
              <legend>Most Recent Data Types</legend>
              <Grid container className={classes.rootBox} spacing={spacing}>
                <Grid item xs={12}>
                  <Grid container justify="center" spacing={spacing}>
                    <Grid xs={12} item>
                      <Paper className={classes.paper}>
                        {
                          (volumeCountDate || volumeClassCountDate || traffiSpeedCountDate) ?
                            <ul className={classes.teamsUl}>
                              {
                                volumeCountDate ?
                                  <li style={{ marginLeft: '0px', marginRight: '50px' }} title='Volume'>
                                    <FontAwesomeIcon icon={faCar} className={classes.btnIcon} /> <br />
                                    {volumeCountDate}
                                  </li> : null
                              }
                              {
                                volumeClassCountDate ?
                                  <li style={{ marginLeft: '0px', marginRight: '50px' }} title='Class'>
                                    <FontAwesomeIcon icon={faTruck} className={classes.btnIcon} /> <br />
                                    {volumeClassCountDate}
                                  </li> : null
                              }
                              {
                                traffiSpeedCountDate ?
                                  <li style={{ marginLeft: '0px', marginRight: '50px' }} title='Speed'>
                                    <FontAwesomeIcon icon={faTachometerAlt} className={classes.btnIcon} /> <br />
                                    {traffiSpeedCountDate}
                                  </li> : null
                              }
                            </ul> : <p style={{ textAlign: 'center' }}> No data has been imported for this station </p>
                        }
                      </Paper>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </fieldset>
            <fieldset className={classes.fieldsetname}>
              <legend style={{ marginBottom: '-10px', }}>Summary</legend>
              {
                (getADTSummery.length > 0 || getTruckPercent.length > 0 || getADTGrowthFactor.length > 0) ?
                  <TableContainer component={Paper}>
                    <Table className={classes.tableMidBlock} aria-label="customized table">
                      <TableHead>
                        <TableRow>
                          <TableCell className={classes.tableHead}></TableCell>
                          {
                            yearList &&
                            yearList.map((year, index) => {
                              return <TableCell key={index} className={classes.tableHead}> {year.year} </TableCell>
                            })
                          }
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <StyledTableRow>
                          <TableCell className={classes.titleTD}>Average Daily Traffic (ADT)</TableCell>
                          {
                            getADTSummery &&
                            getADTSummery.map((adtsummery, index) => {
                              return <TableCell key={index} className={classes.dataTD}> {adtsummery.value} </TableCell>
                            })
                          }
                        </StyledTableRow>

                        <StyledTableRow>
                          <TableCell className={classes.titleTD}>Truck %</TableCell>
                          {
                            getTruckPercent &&
                            getTruckPercent.map((truckpercent, index) => {
                              if (truckpercent.value != "N/A") {
                                return <TableCell key={index} className={classes.dataTD}> {truckpercent.value}% </TableCell>
                              }
                              else {
                                return <TableCell key={index} className={classes.dataTD}> {truckpercent.value} </TableCell>
                              }
                            })
                          }
                        </StyledTableRow>

                        <StyledTableRow>
                          <TableCell className={classes.titleTD}>ADT Annual Growth Rate</TableCell>
                          {
                            getADTGrowthFactor &&
                            getADTGrowthFactor.map((growthfactor, index) => {
                              if (growthfactor.value != "N/A") {
                                return <TableCell key={index} className={classes.dataTD}> {growthfactor.value}% </TableCell>
                              }
                              else {
                                return <TableCell key={index} className={classes.dataTD}> {growthfactor.value} </TableCell>
                              }
                            })
                          }
                        </StyledTableRow>
                      </TableBody>
                    </Table>
                  </TableContainer> : <p style={{ textAlign: 'center' }}> No summary calculations are available for this station </p>
              }
            </fieldset>
            <fieldset className={classes.fieldsetname}>
              <legend>ADT</legend>
              <div className={classes.echartDiv}>
                {
                  eChartGet > 0 ?
                    <ReactEcharts option={myOptions} style={{ marginLeft: '5px' }} /> :
                    <p style={{ textAlign: "center" }}> No ADT calculations are available for this station </p>
                }
              </div>
            </fieldset>
            <fieldset className={classes.fieldsetname} style={{ marginRight: 0 }}>
              <legend>Details</legend>
              <Grid container className={classes.rootBox} spacing={spacing}>
                <Grid item xs={12}>
                  <Grid container justify="center" spacing={spacing}>
                    <Grid xs={12} item>
                      <Paper className={classes.paper} >
                        <span style={{ textTransform: 'capitalize' }}>
                          Status: {stationDetails.status ? stationDetails.status : null}
                        </span> <br />
                        <span>                          
                          Jurisdiction: {stationDetails.Jurisdiction_name ? stationDetails.Jurisdiction_name : <span>N/A</span>}
                        </span> <br />
                        <span>
                          County: {stationDetails.fips_county_code ? stationDetails.fips_county_code : <span>N/A</span>}
                        </span> <br />
                        <span>
                          Community: {stationDetails.community ? stationDetails.community : <span>N/A</span>}
                        </span> <br />
                        <span>
                          Lat / Long: {stationDetails.latitude ? parseFloat(stationDetails.latitude).toFixed(5) + ' , ' : null} {stationDetails.longitude ? parseFloat(stationDetails.longitude).toFixed(5) : null}
                        </span> <br />
                        <span>
                          Speed Limit: {stationDetails.speed_limit ? stationDetails.speed_limit : <span>N/A</span>}
                        </span> <br />
                        <span>
                          Description: {stationDetails.description ? stationDetails.description : <span>N/A</span>}                          
                        </span> <br />
                      </Paper>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </fieldset>
          </div>
        </Grid>
        <Grid item xs={12} sm={6}>
          <div ref={mapRef} className={classes.mapContainer} data-testid='mapView'
            style={{ border: "1px solid #24618e" }}></div>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default MidblockLocationDetails;
//End MidblockLocationDetails component code